import { Contact } from './contact.model';

export class ExtendedCompanyProfile {
    public Primary: Contact;
    public Products: string[];
    public LineNames: string[];
    public CompanyStreetAddress: string;
    public Description: string;
    constructor(){
        this.Primary = new Contact();
        this.Products = [];
        this.LineNames = [];
    }
}